jQuery(function($) {
  //on scroll of window if scrollTop is greater than half of viewport height, add fade_out class to global_cta
  $(window).scroll(function() {
    if ($(window).scrollTop() > 100) {
      $(".global_cta").addClass("fade_out");
    } else {
      $(".global_cta").removeClass("fade_out");
    }
  });
});
  